// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3q6co","newWaypointContainer":"styles-module__newWaypointContainer___1vaRS","adminButtons":"styles-module__adminButtons___3uHIc"};